export default (value, currency) => {
  let auxValue = 0
  if (!isNaN(parseInt(value))) {
    auxValue = value
  }
  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value)
  return formattedValue
}
